import { ActionIcon } from '@mantine/core';
import type { ReactNode } from 'react';
import classes from './ImagePreviewActionButton.module.css';

export interface ImagePreviewActionButtonProps {
  ariaLabel: string;
  children: ReactNode;
  onClick: VoidFunction;
  testId?: string;
}

export function ImagePreviewActionButton({ ariaLabel, children, onClick, testId }: ImagePreviewActionButtonProps) {
  return (
    <ActionIcon
      aria-label={ariaLabel}
      className={classes.previewActionButton}
      data-testid={testId}
      onClick={onClick}
      radius="md"
      size={25}
      variant="filled"
    >
      {children}
    </ActionIcon>
  );
}
